export const PRODUCTIVITY_SCREEN_STATES = {
  REQUIRES_SCALE_PLAN: 'requires_scale_plan',
  REQUIRES_HISTORICAL_ANALYSIS: 'requires_historical_analysis',
  HISTORICAL_ANALYSIS_IN_PROGRESS: 'historical_analysis_in_progress',
  ANALYSIS_PENDING: 'analysis_pending',
  READY: 'ready'
};

const PRODUCTIVITY_SCREEN_COPY = {
  [PRODUCTIVITY_SCREEN_STATES.REQUIRES_SCALE_PLAN]: {
    title: 'AI Insights',
    body: 'Your current plan does not include AI Insights for Productivity Scores. Upgrade to the Scale plan to unlock this section.',
    ctaLabel: 'Go to Plan Configuration',
    ctaPath: '/settings/plan-configuration'
  },
  [PRODUCTIVITY_SCREEN_STATES.REQUIRES_HISTORICAL_ANALYSIS]: {
    title: 'AI Insights',
    body: 'We need at least 12 full months of analysis history to generate Productivity Scores. Extend your analysis window from Historical Analysis to continue.',
    ctaLabel: 'Go to Historical Analysis',
    ctaPath: '/settings/historical-analysis'
  },
  [PRODUCTIVITY_SCREEN_STATES.HISTORICAL_ANALYSIS_IN_PROGRESS]: {
    title: 'AI Insights',
    body: 'Your historical analysis is in progress. We will generate Productivity Scores as soon as the analysis is complete.',
    ctaLabel: 'View Historical Analysis',
    ctaPath: '/settings/historical-analysis'
  },
  [PRODUCTIVITY_SCREEN_STATES.ANALYSIS_PENDING]: {
    title: 'AI Insights',
    body: 'Your historical analysis is complete. We are preparing your Productivity Scores now.',
    ctaLabel: 'View Historical Analysis',
    ctaPath: '/settings/historical-analysis'
  }
};

export const isProductivityScreenBlocked = screenState =>
  Boolean(screenState && screenState !== PRODUCTIVITY_SCREEN_STATES.READY);

export const getProductivityScreenOverlayContent = (
  screenState,
  screenStateMeta = null
) => {
  const content = PRODUCTIVITY_SCREEN_COPY[screenState];

  if (!content) {
    return null;
  }

  return {
    title: content.title,
    body: content.body,
    ctaLabel: screenStateMeta?.cta_label || content.ctaLabel,
    ctaPath: screenStateMeta?.cta_path || content.ctaPath
  };
};
